import { EmissionType, type WMSOverlayer } from "src/types";
import { Z_INDEX } from "src/config/zIndex";
import { GROUPS } from "src/config/overlayers";
import type { WFSGetFeatureParams } from "src/services/ogc.service";

export function getEmissionWMSOverLayer(type: EmissionType, geoserverFilter: number): WMSOverlayer {
  const GEOSERVER_URL = "/geoserver/wms";
  return {
    key: `emission-${type}-${geoserverFilter}`,
    translationKey: `layer.scenario.${type}`,
    url: GEOSERVER_URL,
    layers: getEmissionWMSLayerName(type),
    opacity: 0.8,
    format: "image/png",
    transparent: true,
    legend: { legendType: "wms" },
    isActive: true,

    group: GROUPS.emissions, // TODO: should this be required?
    context: ["case-edit"],

    // @ts-ignore: leaflet type definition insufficient
    viewparams: `shapecollection_id:${geoserverFilter}`,
    styles: `${getEmissionWMSLayerName(type)}_scenario`,
    zIndex: Z_INDEX.emissions, // set default zIndex
  };
}

export function getEmissionWMSLayerName(emissionType: EmissionType): string {
  switch (emissionType) {
    case EmissionType.TRAFFIC:
      return "atmoplan:traffic";
    case EmissionType.POINT_SOURCE:
      return "atmoplan:pointsources";
    default:
      throw new Error(`Unknown emission type ${emissionType}`);
  }
}

export function getEmissionWFSParams(
  type: EmissionType,
  geoserverFilter: number,
  additionalCqlFilter?: string
): WFSGetFeatureParams {
  return {
    typeNames: getEmissionWMSLayerName(type),
    viewParams: `shapecollection_id:${geoserverFilter}`,
    ...(additionalCqlFilter && { cql_filter: additionalCqlFilter }),
  };
}
